import { ErrorHandler, Injectable } from "@angular/core";

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    const errorMessage = error?.message || "";
    const chunkFailedMessage = /Loading chunk [^\s]+ failed/;

    if (
      chunkFailedMessage.test(errorMessage) ||
      error?.message?.includes("Failed to fetch dynamically imported module")
    ) {
      // Optional: check for chunk in URL
      if (error?.message?.includes("chunk-")) {
        console.warn("Detected chunk load failure, reloading...");
        window.location.reload();
        return;
      }
    }

    // Otherwise, rethrow the error or handle normally
    console.error(error);
  }
}
